import { __awaiter } from '../node_modules/tslib/tslib.es6.js';

const copyTextToClipboard = (msg) => __awaiter(void 0, void 0, void 0, function* () {
    const el = document.createElement('div');
    el.innerHTML = msg.text;
    const textWithoutTags = el.textContent || '';
    try {
        yield navigator.clipboard.writeText(textWithoutTags);
        console.log('Text copied to clipboard');
        return true;
    }
    catch (err) {
        console.error('Failed to copy text: ', err);
    }
});

export { copyTextToClipboard };
